// extracted by mini-css-extract-plugin
module.exports = {"time-mid":"Time_time-mid__UKiwx","time-min":"Time_time-min__patFM"};